module.exports = __webpack_public_path__ + "img/20220219_072056.d6e9e609.jpg";